<template>
  <div class="ReactModalPortal order-datetime-modal">
    <div class="ReactModal__Overlay ReactModal__Overlay--after-open " class-open="ReactModal__Overlay--after-open"
         style="position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; background-color: rgba(255, 255, 255, 0.75);"
         aria-modal="true">
      <div
        class="ReactModal__Content overlay xs-full-height xs-full-width xs-mb-0 xs-flex xs-items-center ReactModal__Content--after-open"
        class-open="ReactModal__Content--after-open" tabindex="-1" aria-label="DelayedOrderModal">
        <div class="" style="width: 100%; height: 100%;">
          <div class="asap-message xs-pt-60 xs-px-40 xs-text-white pb-20">
            <p class="xs-mb-20 text-center t24" v-if="message" v-html="message"></p>
            <p v-if="!hideSuggestionText" class="xs-mb-20 xs-t15 text-center t24">{{$t('what_time_would_you_like_your_order')}} </p>
          </div>
          <button type="button"
                  class="icon-close--white xs-p-20 xs-absolute xs-r-20 xs-t-10 close-order-datetime"
                  @click="$emit('close')"></button>
          <div class="text-center">
            <div class="col-md-3 ">
            </div>
            <div class="col-md-3  col-xs-12 ">
              <i class="fa fa-calendar xs-mr-5 fa-o-before-20" style="width: 20px;height: 20px"> </i>
              <select class="select-popup-date-time t22" v-model="choiceDay">
                <option class="dropdown-item"
                        v-for="(item, index) in openingDateTime"
                        :value="index">{{ item.label }}
                </option>
              </select>
            </div>

            <div class="col-md-3 col-xs-12 ">
              <i class="fa fa-clock-o xs-mr-5 fa-o-before-20" style="width: 20px;height: 20px"></i>
              <select class="select-popup-date-time t22" v-model="choiceHour">
                <option class="dropdown-item" v-for="hour in hours" :value="hour">{{hour}}</option>
              </select>
            </div>
            <div class=" pt-100 action-save-date-time">
              <button style="width: 45%;margin: auto; background: #e9ebee;" type="button"
                      class="button button--primary xs-text-center save-date-time" @click="setTime()">
                {{$t('modal.set_order_time')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment-timezone'
import main from '../../main.js'
import {mapGetters} from 'vuex'

export default {
  props: ['outletId', 'outletDataZip', 'outletDataLocalization', 'orderType', 'hideASAP', 'message', 'onCheckAvailableHut', 'hideSuggestionText', 'reloadPaymentList', 'reOrder'],
  comments: {},
  beforeCreate: function () {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-asap');
  },
  beforeDestroy: function () {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-asap');
  },
  created(){
    this.callEventBus(this.$const.EVENT_BUS.LOADING, true)
  },
  mounted() {
    let data = {
      'id': 'delivery-time',
      'name': 'delivery-time',
      'type': 'tool',
      'placement': 'floating',
      'items': [
        {
          'id': 'delivery-time-1',
          'type': 'tool',
          'position': '1'
        }
      ],
      'assets': {
        'tools': [
          {
            'id': 'delivery-time-1',
            'type': 'selector',
            'name': 'delivery-time',
            'attributes': {
              'function': 'select-delivery-slot'
            }
          }
        ]
      }
    }
    this.eventTrackingModuleLoad(data)
    this.$disposition.init(this)
    this.init()
  },
  data() {
    return {
      selected: null,
      timezone: null,
      quoteTime: null,
      choiceDay: '',
      choiceHour: '',
      openingDateTime: [],
      hours: [],
      dataOutlet: {
        name: '',
        phone: ''
      }
    }
  },
  watch: {
    choiceDay: function (newValue, oldValue) {
      this.hours = typeof this.openingDateTime[newValue] !== 'undefined' ? this.openingDateTime[newValue].data : []
      this.quoteTime = this.openingDateTime[newValue].quoteTime
      let exist = this.hours.includes(this.choiceHour)
      if(!exist){
        this.choiceHour = this.hours[0]
      }

      if (oldValue == '') {
        let h = this.$disposition.getByKey(this, 'collectionTime', '')
        if (h != '' && this.$disposition.getByKey(this, 'advanceOrder', '') == 1) {
          if (this._.indexOf(this.hours, h.pickedHours) >= 0) {
            this.choiceHour = h.pickedHours
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isValidOrderTime: 'isValidOrderTime'
    })
  },
  methods: {
    /**
     * Init data after load page
     * */
    init() {
      let id = 0
      if (typeof this.outletId !== 'undefined' && this.outletId) {
        id = this.outletId
      } else if (!this.empty(this.$disposition.getByKey(this, 'outletId', ''))) {
        id = this.$disposition.getByKey(this, 'outletId', '')
      }
      var vm = this
      let order_type = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D')
      this.axios.apiOutlet.getOutletOpeningHours({outletId: id, order_type: order_type.charAt(0)}, function (response) {
        let items = response.data.data.items
        let info = response.data.data.info || {}
        vm.dataOutlet.name = info.name
        vm.dataOutlet.phone = info.phone
        if (!vm.empty(items)) {
          vm.timezone = items[0].info.timezone
          vm.setData(items)
        } else {
          vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
        }
      })
    },

    setData(data) {
      let vm = this
      this.openingDateTime = {}

      let defaultDate = this.$disposition.getByKey(this, 'collectionTime', '')
      let order_type = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D')
      let now = moment().tz(vm.timezone)
      let tomorrow = moment().tz(vm.timezone).add(1, 'days')

      for (let _d in data) {
        let obTime = []
        moment.locale(vm.$session.get('lang'))
        let date = moment.utc(data[_d].date).tz(vm.timezone)
        let dayWeek = moment(date).format('ddd')
        let asapVisible = false
        let absolutelyAsap = false
        if (data[_d].info.stop_order != 1 && (date.format('YYYY') > now.format('YYYY') || date.dayOfYear() >= now.dayOfYear())) {
          let dateFormat = date.format('YYYY-MM-DD')
          let info = data[_d].info
          let _originStartTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, vm.timezone)
          let startTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.start_time, vm.timezone)
                              .add(info.quote_time, 'minutes')
          let endTime = this.convertUTCToTimeZone(dateFormat + ' ' + info.end_time, vm.timezone)

          startTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          _originStartTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          endTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          if (endTime.format('HH:mm:ss') == '00:00:00') {
            endTime.set('hour', 23)
            endTime.set('minute', 55)
            endTime.set('second', 0)
          }
          let startTimeOrigin = this._.cloneDeep(startTime)

          //TODAY
          // let nextMinute = null
          let currentTime = moment(moment().tz(vm.timezone).format('YYYY-MM-DD HH:mm'))
          if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
            // if (now.isAfter(startTime)) {
            //   startTime = moment().tz(vm.timezone).add(info.quote_time, 'minutes')
            // }

            if (currentTime.isSameOrBefore(endTime) && currentTime.isSameOrAfter(_originStartTime)) {
              asapVisible = true
              absolutelyAsap = true
            }
            //check duration
            if (!absolutelyAsap) {
              let cloneEndtime = this._.cloneDeep(endTime)
              let cloneEndtimeDuration = this.getEndTime(info, cloneEndtime, order_type)
              cloneEndtime.hour(cloneEndtimeDuration.get('hour'))
              cloneEndtime.minute(cloneEndtimeDuration.get('minute'))
              if (currentTime.isSameOrBefore(cloneEndtime) && currentTime.isSameOrAfter(_originStartTime)) {
                asapVisible = true
              }
            }
          }
          let intervalValue = vm.getInterval(info, startTime, order_type)
          if (intervalValue != null) {
            if (intervalValue == -1) {
              intervalValue = info.interval
            }
          } else {
            intervalValue = info.interval
          }

          // Specific handle time range for ONLY TODAY
          // if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
          //   nextMinute = intervalValue * (Math.floor(startTime.get('minute') / intervalValue))

          //   // eslint-disable-next-line no-unmodified-loop-condition
          //   while (nextMinute < startTime.get('minute') && intervalValue > 0) {
          //     nextMinute += intervalValue
          //   }
          //   startTime.minute(nextMinute)
          // }

          // if (absolutelyAsap) {
          //   asapVisible = true
          // } else if (asapVisible && !startTime.isSameOrBefore(currentTime)) {
          //   asapVisible = false
          // }

          const checkNextTime = currentTime.minute(currentTime.get('minute') + info.quote_time + intervalValue)
          while (startTime.isSameOrBefore(endTime)) {
            let currentFormat = startTime.format('HH:mm')
            let interval = vm.getInterval(info, startTime, order_type)
            let isAdd = true

            // Check today time
            if (now.format('YYYY-MM-DD') === date.format('YYYY-MM-DD') &&
              (startTime.get('hour') * 60 + startTime.get('minute') < checkNextTime.get('hour') * 60 + checkNextTime.get('minute'))) {
              isAdd = false
            }

            if (interval != null) {
              if (interval == -1) {
                isAdd = false
                interval = info.interval
              }
            } else {
              interval = info.interval
            }

            // expired time (eg: 23:45 - 00:00)
            let nextTime = this._.cloneDeep(startTime)
            nextTime.add(interval, 'minutes')
            if (nextTime.format('YYYY-MM-DD HH:mm') > endTime.format('YYYY-MM-DD HH:mm')) {
              isAdd = false
            }
            // end expired time

            startTime = startTime.add(interval, 'minutes')

            if (isAdd) {
              if (order_type == vm.$const.CARRYOUT) {
                obTime.push(currentFormat)
              } else {
                let format = currentFormat + ' - ' + startTime.format('HH:mm');
                obTime.push(format)
              }
            }
          }

          if (!this.empty(obTime) || asapVisible) {
            this.setDateTime(dateFormat, obTime,
              now.format('YYYY-MM-DD'),
              tomorrow.format('YYYY-MM-DD'), startTimeOrigin, asapVisible, info.name, info.quote_time, dayWeek)
          }
        }
      }
      this.setDefaultChosen(defaultDate)

      this.callEventBus(this.$const.EVENT_BUS.LOADING, false)
    },
    getInterval(data, currentTime, order_type) {
      let vm = this
      let interval = null;

      if (data.advance_duration && data.advance_duration.length) {
        for (let i in data.advance_duration) {
          let item = data.advance_duration[i];
          let date = moment.utc(item.date).tz(vm.timezone)
          let closeTime = this.convertUTCToTimeZone(item.date + ' ' + item.closing, vm.timezone);
          let openTime = this.convertUTCToTimeZone(item.date + ' ' + item.opening, vm.timezone);
          closeTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          openTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))

          if (closeTime.format('HH:mm:ss') == '00:00:00') {
            closeTime.set('hour', 23)
            closeTime.set('minute', 55)
            closeTime.set('second', 0)
          }
          if (currentTime.isSameOrAfter(openTime) && currentTime.isBefore(closeTime)) {
            if (order_type == vm.$const.DELIVERY) {
              interval = item.duration.D
            } else {
              interval = item.duration.C
            }

            break;
          }
        }
      }

      return interval;
    },

    getEndTime (data, endTime, orderType) {
      let cloneEndTime = this._.cloneDeep(endTime)
      let vm = this
      let interval = null
      let closing = moment(cloneEndTime.format('HH:mm:ss'), 'HH:mm:ss')
      if (data.advance_duration && data.advance_duration.length) {
        for (let i in data.advance_duration) {
          let item = data.advance_duration[i]
          let date = moment.utc(item.date).tz(vm.timezone)
          let newClosing = moment.utc(item.closing, 'HH:mm:ss').tz(vm.timezone)
          newClosing.year(date.get('year')).month(date.get('month')).date(date.get('date'))

          if (newClosing.format('HH:mm:ss') == '00:00:00') {
            newClosing.set('hour', 23)
            newClosing.set('minute', 55)
            newClosing.set('second', 0)
          }
          if (moment(closing.format('YYYY-MM-DD HH:mm:ss')).isSameOrBefore(newClosing.format('YYYY-MM-DD HH:mm:ss'))) {
            if (orderType == vm.$const.DELIVERY) {
              interval = item.duration.D
            } else {
              interval = item.duration.C
            }

            if (interval == -1) {
              closing = moment.utc(item.opening, 'HH:mm:ss').tz(vm.timezone)
              closing.year(date.get('year')).month(date.get('month')).date(date.get('date'))
            }
            break
          }
        }
      }

      return closing
    },
    setDateTime(obDate, obTime, today, tomorrow, startTimeOrigin, asapVisible, holiday, quoteTime, dayWeek) {
      let label = ''
      if(obDate == today){
        label = this.$t('today') + `${holiday ? '' : ' (' + dayWeek + ')'}` 
      }else if(obDate == tomorrow){
        label = this.$t('tomorrow') + `${holiday ? '' : ' (' + dayWeek + ')'}` 
      }else {
        let arrarys = obDate.split('-')
        label = arrarys['1'] + '-' + arrarys['2'] + `${holiday ? '' : ' (' + dayWeek + ')'}` 
      }
       if (holiday && holiday != '') {
         label += ' ('+ dayWeek + '-' + holiday + ')'
       }

      if (!this.openingDateTime[obDate]) {
        this.openingDateTime[obDate] = {'label': label, 'data': obTime, 'quoteTime': quoteTime}
      } else {
        let oldData = this.openingDateTime[obDate].data
        let newData = obTime
        this.openingDateTime[obDate].data = oldData.concat(newData)
				this.openingDateTime[obDate].quoteTime = quoteTime
      }

      let hide = false
      if (this.hideASAP && this.hideASAP == 'true') {
        hide = true
      }
      if (obDate == today && !hide) {
        // check hide asap when asap time not available to order
        let time = moment.tz(this.timezone).format('HH:mm')
        let timestart = startTimeOrigin.format('HH:mm')
        if (time >= timestart || asapVisible) {
          this.openingDateTime[obDate].data.unshift(this.$t('asap'))
        }
      }

      if (this.openingDateTime[obDate].data.length <= 0) {
        delete this.openingDateTime[obDate]
      }
    },
    /**
     * Set time default
     * */
    setDefaultChosen(defaultDate) {
      let flag = false
      if (this.$disposition.getByKey(this, 'advanceOrder', '') == 1) {
        for (let date in this.openingDateTime) {
          if (date == defaultDate.pickedDay) {
            this.choiceDay = defaultDate.pickedDay
            this.hours = this.openingDateTime[date].data
            if (this._.indexOf(this.openingDateTime[date].data, defaultDate.pickedHours) >= 0) {
              this.choiceHour = defaultDate.pickedHours
            } else {
              this.choiceHour = this.openingDateTime[date].data[0]
            }
            flag = true
            break
          }
        }
      }

      if (!flag) {
        for (let date in this.openingDateTime) {
          this.choiceDay = date
          this.hours = this.openingDateTime[date].data
          this.choiceHour = this.openingDateTime[date].data[0]
          flag = true
          break
        }
      }
    },
    /**
     * Set Collection time and redirect page
     * */
    setTime: function () {
			let orderType = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
			let timepicker = {'pickedDay': this.choiceDay, 'pickedHours': this.choiceHour}
      let data = this.$disposition.get(this)
      data.collectionTime = timepicker
      data.collectionTimeText = this.choiceDay + ' ' + this.choiceHour
      let time = this.choiceHour.split(' - ')
      if (time.length > 1) {
        time = time[1]
      } else if (time.length > 0) {
        time = time[0]
      }
      data.collectionTimeValue = this.choiceDay + ' ' + time
      data.timezone = this.timezone
      data.advanceOrder = 1
      data.quoteTime = {
				[orderType]: this.openingDateTime[this.choiceDay].quoteTime
      }

      if (this.choiceHour == this.$t('asap')) {
        data.advanceOrder = 0
      }
      this.$disposition.set(this, data)
      this.$emit('close')
      // call api to update order time
      this.$cart.updateOrderTime(this, {'order_time': this.getTimePickerDate(this)})
      this.$root.$emit('collectionTimeUpdate')
      if (this.outletDataZip) {
       this.$root.$emit('onCheckValidOutletZipCode', this.outletDataZip)
      }
      if (this.outletDataLocalization && this.reOrder) {
        this.$root.$emit('onCheckValidOutletReOrder', this.outletDataLocalization)
      } else if (this.outletDataLocalization) {
        this.$root.$emit('onCheckValidOutlet', this.outletDataLocalization)
      }

      if (this.onCheckAvailableHut) {
        this.$root.$emit('onCheckAvailableHut')
      }

      if (this.reloadPaymentList) {
        this.$root.$emit('onLoadPaymentList')
      }

      this.callEventBus(this.$const.EVENT_BUS.LOAD_CATEGORY, true)
    }
  }
}
</script>
<style scoped>
  select {
    border: none;
    background: transparent;
    /*background-color: blue;*/
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-top: 0px;
    background-size: 20px;
    color: #ffffff !important;
  }

  select.select-popup-date-time .dropdown-item {
    font-size: 15px !important;
  }

  .select-popup-date-time {
    border: 0;
    border-bottom: 1px solid #999;
    background: none;
    color: #fff !important;
    width: 79%;
  }

  .fa {
    color: #fff;
  }

  @media (max-width: 800px) {
    .xs-text-15{
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/OrderASAP.vue